export const propertiesHash = {
  card_number_per_email: {
    heading: 'Email used with more than 3 cards in 24 hours',
    label: ' relative_velocity(card_per_email_address, 24h, attempted) > 3',
    description: 'Counts the number of unique cards used for the email address over 24 hours, and triggers if more than 3 different cards have been used',
    type: 'relative_velocity',
    color: 'black',
  },
  email_per_device: {
    heading: 'Device used more than 3 emails',
    label: ' relative_velocity(email_address_per_ip_address, 24h, attempted) > 3',
    description: 'Counts the number of unique email addresses used for the device over 24 hours, and triggers if more than 3 different emails have been used',
    type: 'relative_velocity',
    color: 'black',
  },
  bin_1500: {
    heading: 'BIN declined more than 1,500 times in customer-initiated transactions on a US card in 3 hours',
    label: ' velocity(bin, 3h, declined) > 1500 AND :card_country: = "US"',
    description: 'Counts the number of times the same BIN was seen over 3 hours in all declined transactions, and triggers if it was (1) more than 1500 times, (2) a US card',
    type: 'velocity',
    color: 'black',
  },
  card_number_cardholder_name: {
    heading: 'Card attempted more than 8 times in 1 hour',
    label: ' velocity(card, 1h, attempted) > 8',
    description: 'Counts the number of times an email and a card was seen over 1 hour in all attempted transactions, and triggers if either is more than 8',
    type: 'velocity',
    color: 'black',
  },
  card_number_declined_5: {
    heading: 'Card declined more than 5 times in 3 hour',
    label: ' velocity(card, 3h, declined) > 5',
    description: 'Counts the number of times an card was seen over 3 hours in all declined transactions, and triggers if its more than 5',
    type: 'velocity',
    color: 'black',
  },
  card_number_attempted_4: {
    heading: 'Card attempted more than 4 times in 5 minutes',
    label: ' velocity(card, 5m, attempted) > 4',
    description: 'Counts the number of times a card was seen over 5 minutes in all attempted transactions, and triggers if its more than 4',
    type: 'velocity',
    color: 'black',
  },
  Card_billing_IP: {
    heading: 'Card, billing and IP country do not match',
    label: ' :ip_address_country: != :billing_address_country: AND :ip_address_country: != :card_country:',
    description: 'Triggers if the payment IP country are different from the card country and the billing address country',
    type: '',
    color: 'black',
  },
  IP_Card_Country: {
    heading: 'IP and card country do not match',
    label: ' :ip_address_country: != :card_country:',
    description: 'Triggers if the payment IP country is different from the card country',
    type: '',
    color: 'black',
  },
  amount: {
    label: ':amount:',
    description:
      'The transaction amount in transaction currency. This attribute is mandatory and will always be present in an accepted payment request. This is a numeric value and supports all operators',
    type: 'number',
    color: '#D98E50',
  },
  currency: {
    label: ':currency:',
    description:
      'The currency used for the payment. This attribute is mandatory and will always be present in an accepted payment request. Attention: These currencies are allowed. "PKR", "OMR", "AED", "AUD", "CAD", "GBP", "SAR", "USD"',
    type: 'string',
    color: '#4780EC',
  },
  billing_address_city: {
    label: ':billing_address_city:',
    description: 'The billing address city provided. Example: London',
    type: 'string',
    color: '#4780EC',
  },
  billing_address_country: {
    label: ':billing_address_country:',
    description: 'Returns the billing address country. Attention: countries in this field are defined by 2 character ISO codes. Example: "PK", "SA", "OM", "GB", "FR", "AE", "US"',
    type: 'string',
    color: '#4780EC',
  },
  billing_address_postal_code: {
    label: ':billing_address_postal_code:',
    description:
      'The post code of the billing address. Attention: The values are not validated and are taken as is from the payment request. When used in a rule the exact value match is expected for the rule to be triggered.  Example: 90 Tottenham Court Road',
    type: 'string',
    color: '#4780EC',
  },
  /*  payment_ip_country: {
    label: ':payment_ip_country:',
    description: 'The country as derived from payers IP. Attention: countries in this field are defined by 2 character ISO codes. Example: "PK", "SA", "OM", "GB", "FR", "AE", "US"',
    type: 'string',
    color: '#4780EC',
  },
  payment_ip: {
    label: ':payment_ip:',
    description: 'The IP address used to make the payment.  Example: 168.16.10.2',
    type: 'string',
    color: '#4780EC',
  }, */
  shipping_address_city: {
    label: ':shipping_address_city:',
    description: 'The shipping address city provided. Example: London',
    type: 'string',
    color: '#4780EC',
  },
  shipping_address_country: {
    label: ':shipping_address_country:',
    description: 'Returns the shipping address country. Attention: countries in this field are defined by 2 character ISO codes. Example: "PK", "SA", "OM", "GB", "FR", "AE", "US"',
    type: 'string',
    color: '#4780EC',
  },
  shipping_address_postal_code: {
    label: ':shipping_address_postal_code:',
    description:
      'The second line of the billing address. Attention: The values are not validated and are taken as is from the payment request. When used in a rule the exact value match is expected for the rule to be triggered.  Example: 90 Tottenham Court Road',
    type: 'string',
    color: '#4780EC',
  },
  bin: {
    label: ':bin:',
    description:
      'The bank identification number (BIN) represented by the first six or eight numbers of the credit card. Example: 454347 or 45434778 This attribute is mandatory and will always be present in an accepted payment request.',
    type: 'string',
    color: '#4780EC',
  },
  card_brand: {
    label: ':card_brand:',
    description: 'The brand of the credit card used. Example: VISA, MASTERCARD, AMEX',
    type: 'string',
    color: '#4780EC',
  },
  card_country: {
    label: ':card_country:',
    description:
      'Returns the country where the card was issued as derived from the card bin. Attention: countries in this field are defined by 2 character ISO codes. Example: "PK", "SA", "OM", "GB", "FR", "AE", "US"',
    type: 'string',
    color: '#4780EC',
  },
  card_issuer_name: {
    label: ':card_issuer_name:',
    description: 'Issuing bank name. Example: "BARCLAYS BANK UK PLC, HSBC UK BANK PLC"',
    type: 'string',
    color: '#4780EC',
  },
  /*  card_fingerprint: {
    label: ':card_fingerprint:',
    description: 'Checkouts unique ID of a card.     Example: "9F3BAD2E48C6C8579F2F5DC0710B7C..."',
    type: 'string',
    color: '#4780EC',
  }, 
    card_type: {
    label: ':card_type:',
    description: 'The type of the card used for payment. Example: Credit, Debit',
    type: 'string',
    color: '#4780EC',
  }, 
  cardholder_name: {
    label: ':cardholder_name:',
    description: 'The name of the cardholder.  Example: John Doe',
    type: 'string',
    color: '#4780EC',
  },
  customer_name: {
    label: ':customer_name:',
    description: 'The name of the customer.  Example: John Doe',
    type: 'string',
    color: '#4780EC',
  },
    email_domain: {
    label: ':email_domain:',
    description: 'The e-mail domain derived from the customer e-mail address. Example: domain.com',
    type: 'string',
    color: '#4780EC',
  },
  email: {
    label: ':email:',
    description: 'The customer e-mail address provided. Example: john.doe@example.com',
    type: 'string',
    color: '#4780EC',
  }, 
  phone_country: {
    label: ':phone_country:',
    description:
      'The country of the customers phone number. Derived from the first 2 digit of the number provided. Attention: countries in this field are defined by 2 character ISO codes. Example: "PK", "SA", "OM", "GB", "FR", "AE", "US"',
    type: 'string',
    color: '#4780EC',
  },
   phone: {
    label: ':phone:',
    description: 'The phone number of the customer provided. Example: +1415 555 2671',
    type: 'string',
    color: '#4780EC',
  }, */
  ip_address_country: {
    label: ':ip_address_country:',
    description: 'The country from where the payment was done.  Example: "PK", "SA", "OM", "GB", "FR", "AE", "US"',
    type: 'string',
    color: '#4780EC',
  },
  ip_address: {
    label: ':ip_address:',
    description: 'The IP address from where the payment was done. Example: 168.16.10.2',
    type: 'string',
    color: '#4780EC',
  },
  authentication_not_in_effect: {
    label: ':authentication_not_in_effect:',
    description: 'It must be boolean value. true or false',
    type: 'boolean',
    color: '#6964B2',
  },
  '!=': {
    label: ' != ',
    description: 'Not equal. All evaluated attributes must be of the same type: String, Number or Boolean. Example: :card_brand: != "VISA"',
    type: 'operator',
    color: 'black',
  },
  '<': {
    label: ' < ',
    description: 'Less than. Applicable to number attributes only. Example: :score: < 5',
    type: 'operator',
    color: 'black',
  },
  '<=': {
    label: ' <= ',
    description: 'Less than or equal. Applicable to number attributes only. Example: :score: <= 2',
    type: 'operator',
    color: 'black',
  },
  '=': {
    label: ' = ',
    description: 'Equal. All evaluated attributes must be of the same type: String, Number or Boolean. Example: :billing_address_country: = "GB"',
    type: 'operator',
    color: 'black',
  },
  '>': {
    label: ' > ',
    description: 'Greater than. Applicable to number attributes only. Example: :score: > 5',
    type: 'operator',
    color: 'black',
  },
  '>=': {
    label: ' >= ',
    description: 'Greater than or equal. Applicable to number attributes only. Example: :score: >= 1',
    type: 'operator',
    color: 'black',
  },
  AND: {
    label: ' AND ',
    description: 'All conditions must be true for the rule to pass. Example: (card_country = "US" AND device_trusted = true)',
    type: 'operator',
    color: 'black',
  },
  OR: {
    label: ' OR ',
    description: 'At least one condition must be true for the rule to pass. Example: (card_country = "US" OR device_trusted = true)',
    type: 'operator',
    color: 'black',
  },
  /*   exists: {
    label: ':exists:',
    description: 'Attribute is present. Or, in other words, has a value. Example: exists(:billing_address_country:) will return TRUE if an address is provided',
    type: 'string',
    color: 'rgb(90, 85, 163)',
  },
  not: {
    label: ':not:',
    description: 'Reverses a condition. Example: not(:billing_address_city: CONTAINS London) will return TRUE if billing address city does NOT contain London',
    type: 'string',
    color: 'rgb(90, 85, 163)',
  }, */
};

export const properties = {
  'Amount and Currency': [propertiesHash.amount, propertiesHash.currency],
  Addresses: [
    propertiesHash.billing_address_city,
    propertiesHash.billing_address_country,
    propertiesHash.billing_address_postal_code,
    /* propertiesHash.payment_ip_country,
    propertiesHash.payment_ip, */
    propertiesHash.shipping_address_city,
    propertiesHash.shipping_address_country,
    propertiesHash.shipping_address_postal_code,
  ],
  'Card details': [propertiesHash.bin, propertiesHash.card_brand, propertiesHash.card_country, propertiesHash.card_issuer_name /*, propertiesHash.card_fingerprint,  propertiesHash.card_type */],
  /* 'Customer profile': [
     propertiesHash.cardholder_name, propertiesHash.customer_name,  propertiesHash.phone_country,  propertiesHash.phone, propertiesHash.email_domain, propertiesHash.email 
  ],*/
  'Device data': [propertiesHash.ip_address_country, propertiesHash.ip_address],
  'Verification results': [propertiesHash.authentication_not_in_effect],
};
export const operators = {
  Operators: [propertiesHash['!='], propertiesHash['<'], propertiesHash['<='], propertiesHash['='], propertiesHash['>'], propertiesHash['>=']],
  'Logical operators': [propertiesHash['AND'], propertiesHash['OR']],
  // Functions: [propertiesHash.exists, propertiesHash.not],
};
export const Library = {
  'Velocity rules': [
    propertiesHash.card_number_per_email,
    propertiesHash.email_per_device,
    propertiesHash.bin_1500,
    propertiesHash.card_number_cardholder_name,
    propertiesHash.card_number_declined_5,
    propertiesHash.card_number_attempted_4,
  ],
  'Consistency rules': [propertiesHash.Card_billing_IP, propertiesHash.IP_Card_Country],
};

export const relative_attributes = [
  /*  {
    label: 'Cardholder name',
    value: 'cardholder_name',
  }, */
  {
    label: 'Card',
    value: 'card',
  },
  {
    label: 'Card country',
    value: 'card_country',
  },
  {
    label: 'Email Address',
    value: 'email_address',
  },
  {
    label: 'Billing Address',
    value: 'billing_address',
  },
  {
    label: 'IP Address',
    value: 'ip_address',
  },
  {
    label: 'IP Address country',
    value: 'ip_address_country',
  },
  {
    label: 'BIN',
    value: 'bin',
  },
  /*   {
    label: 'Email domain',
    value: 'email_domain',
  }, */
  {
    label: 'Phone number',
    value: 'phone_number',
  },
];

export const options = [
  { label: 'Attempted', value: 'attempted' },
  { label: 'Approved', value: 'approved' },
  { label: 'Declined', value: 'declined' },
];

export const frequency = [
  { label: 'Minutes', value: 'm' },
  { label: 'Hours', value: 'h' },
  { label: 'Days', value: 'd' },
];

export const transaction_attributes = [
  /*  {
    label: 'Cardholder name',
    value: 'cardholder_name',
  }, */
  {
    label: 'Card',
    value: 'card',
  },
  {
    label: 'Email Address',
    value: 'email_address',
  },
  {
    label: 'Billing Address',
    value: 'billing_address',
  },
  {
    label: 'Shipping Address',
    value: 'shipping_address',
  },
  {
    label: 'IP Address',
    value: 'ip_address',
  },
  {
    label: 'BIN',
    value: 'bin',
  },
];

export const stringOnlyFields = [
  ':currency:',
  ':billing_address_city:',
  ':billing_address_country:',
  ':billing_address_postal_code:',

  ':shipping_address_city:',
  ':shipping_address_country:',
  ':shipping_address_postal_code:',
  ':card_country:',
  ':card_issuer_name:',
  /*':cardholder_name:',
  ':customer_name:', 
  ':payment_ip_country:',
  ':payment_ip:',
  ':phone_country:', */
  ':card_brand:',
  ':bin:',
  ':ip_address_country:',
  ':ip_address:',
];

export const commonProperties = [
  ':amount:',
  ':currency:',
  ':billing_address_city:',
  ':billing_address_country:',
  ':billing_address_postal_code:',
  ':shipping_address_city:',
  ':shipping_address_country:',
  ':shipping_address_postal_code:',
  ':bin:',
  ':card_brand:',
  ':card_country:',
  ':card_issuer_name:',
  /*':card_fingerprint:',
  ':card_type:',
  ':cardholder_name:',
  ':customer_name:',
  ':email_domain:',
  ':payment_ip_country:',
  ':payment_ip:',
  ':email:',
  ':phone:', 
  ':phone_country:',*/
  ':ip_address_country:',
  ':ip_address:',
  ':authentication_not_in_effect:',
  'AND',
  'OR',
];

export const comparisonAllowedProps = [
  ':billing_address_city:',
  ':billing_address_country:',
  ':billing_address_postal_code:',
  ':shipping_address_city:',
  ':shipping_address_country:',
  ':shipping_address_postal_code:',
  ':card_country:',
  ':card_issuer_name:',
  /*':cardholder_name:',
  ':customer_name:', 
  ':payment_ip_country:',
  ':payment_ip:',
  ':phone_country:',*/
  ':ip_address_country:',
  ':ip_address:',
];
